import React, { useState, useEffect } from "react";
import "../../../css/MonthWeekRental.css";
import { useDispatch, useSelector } from "react-redux";
import { RentalMonthWeek, fetchAsyncRentalMonthWeek } from "../RentalSlice";
import {
  ComposedChart,
  Tooltip,
  XAxis,
  CartesianGrid,
  Legend,
  YAxis,
  Bar,
  ResponsiveContainer,
} from "recharts";

const MonthWeekRental = () => {
  const dispatch = useDispatch();
  const RentalMonthWeekData = useSelector(RentalMonthWeek);

  const handlePage = (item: number) => {
    setPage(page + item);
  };

  const [page, setPage] = useState(1);

  useEffect(() => {
    // 初回描画時に実行する処理
    dispatch(fetchAsyncRentalMonthWeek(page));

    // 定期実行を設定
    const interval = setInterval(() => {
      dispatch(fetchAsyncRentalMonthWeek(page));
    }, 60000); // 60秒ごとに実行

    // コンポーネントのクリーンアップ時にインターバルをクリア
    return () => clearInterval(interval);
  }, [dispatch, page]); // 依存配列にdispatchを含める

  return (
    <div className="week_month_rental_container">
      <div className="week_month_title_container">
        <div className="back" onClick={() => handlePage(1)}>
          ←
        </div>
        {RentalMonthWeekData && RentalMonthWeekData.length > 0 && (
          <h2 className="week_month_title">
            曜日別レンタル件数/{RentalMonthWeekData![0]["month"]}
          </h2>
        )}
        {RentalMonthWeekData && RentalMonthWeekData.length < 1 && (
          <h2 className="week_month_title">曜日別レンタル件数/</h2>
        )}
        <div
          className="next"
          onClick={() => {
            handlePage(-1);
          }}>
          →
        </div>
      </div>
      <ResponsiveContainer height="70%" width="90%">
        <ComposedChart
          height={300}
          data={RentalMonthWeekData!}
          className="bar_chart">
          <XAxis dataKey="week" />
          <YAxis dataKey="count" />
          <Tooltip />
          <Legend />
          <CartesianGrid stroke="#f5f5f5" />
          <Bar
            dataKey="count"
            barSize={20}
            stroke="rgba(34, 80, 162, 0.2)"
            fillOpacity={1}
            fill="#4cceac"
            name="レンタル件数"
          />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
};

export default MonthWeekRental;
